<template>
  <div
    class="group relative bg-white dark:bg-dark-surface rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 dark:border-gray-800 overflow-hidden will-change-transform"
  >
    <!-- Background Gradient -->
    <div
      class="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-primary/5 dark:from-accent/10 dark:to-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    ></div>

    <!-- Content -->
    <div class="relative z-10">
      <!-- Icon -->
      <div
        v-if="icon"
        class="w-12 h-12 bg-gradient-to-br from-primary/10 to-accent/10 dark:from-primary/20 dark:to-accent/20 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300"
      >
        <component
          :is="icon"
          :size="24"
          class="text-accent dark:text-accent-300"
        />
      </div>

      <!-- Number -->
      <div class="flex items-baseline mb-2">
        <span
          class="text-5xl md:text-6xl font-display font-bold text-gray-900 dark:text-white"
        >
          {{ number }}
        </span>
        <span
          v-if="suffix"
          class="text-3xl md:text-4xl font-display font-bold text-accent dark:text-accent-300 ml-1"
        >
          {{ suffix }}
        </span>
      </div>

      <!-- Label -->
      <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-2">
        {{ label }}
      </h3>

      <!-- Description -->
      <p
        v-if="description"
        class="text-sm text-gray-600 dark:text-gray-400"
      >
        {{ description }}
      </p>
    </div>

    <!-- Corner Accent -->
    <div
      class="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-accent/10 to-transparent dark:from-accent/20 rounded-bl-full transform translate-x-12 -translate-y-12 group-hover:scale-150 transition-transform duration-300"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  number: {
    type: Number,
    required: true
  },
  suffix: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  icon: {
    type: Object,
    default: null
  },
  animated: {
    type: Boolean,
    default: true
  }
});
</script>
